import baseTemplate from 'text!./ProducerUnderwritingIssues.html';
import styles from './ProducerUnderwritingIssues-hashed.scss';
import controller from './ProducerUnderwritingIssuesCtrl';
import cssUtil from 'gw-portals-util-js/CssUtil';


const template = cssUtil.hashTemplate(baseTemplate, styles);

export default {
    bindings: {
        submission: '=',
        issuesByOffering: '<',
        anonymousOfferings: '<?'
    },
    controller,
    template
};